import {Component, OnInit} from '@angular/core';
import {CommonInputComponent} from '../common-input/common-input.component';

@Component({
  selector: 'app-degree-select',
  templateUrl: './degree-select.component.html',
  styleUrls: ['./degree-select.component.scss']
})
export class DegreeSelectComponent extends CommonInputComponent implements OnInit {
  public degrees = [1, 2, 3];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
  }
}
